var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHireIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 18.72L53.6213 10.4907",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3333 12C60.2789 12 62.6667 9.61217 62.6667 6.66665C62.6667 3.72113 60.2789 1.33331 57.3333 1.33331C54.3878 1.33331 52 3.72113 52 6.66665C52 9.61217 54.3878 12 57.3333 12Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8987 47.944L53.5387 53.6186",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.36 62.6667C60.3055 62.6667 62.6933 60.2789 62.6933 57.3333C62.6933 54.3878 60.3055 52 57.36 52C54.4145 52 52.0267 54.3878 52.0267 57.3333C52.0267 60.2789 54.4145 62.6667 57.36 62.6667Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 18.72L10.3813 10.4907",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 12C9.61217 12 12 9.61217 12 6.66665C12 3.72113 9.61217 1.33331 6.66665 1.33331C3.72113 1.33331 1.33331 3.72113 1.33331 6.66665C1.33331 9.61217 3.72113 12 6.66665 12Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.104 47.944L10.4613 53.6186",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63997 62.6667C9.58549 62.6667 11.9733 60.2789 11.9733 57.3333C11.9733 54.3878 9.58549 52 6.63997 52C3.69446 52 1.30664 54.3878 1.30664 57.3333C1.30664 60.2789 3.69446 62.6667 6.63997 62.6667Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 30.6666H52",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3333 36C60.2789 36 62.6667 33.6122 62.6667 30.6666C62.6667 27.7211 60.2789 25.3333 57.3333 25.3333C54.3878 25.3333 52 27.7211 52 30.6666C52 33.6122 54.3878 36 57.3333 36Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.6666H12",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 36C9.61217 36 12 33.6122 12 30.6666C12 27.7211 9.61217 25.3333 6.66665 25.3333C3.72113 25.3333 1.33331 27.7211 1.33331 30.6666C1.33331 33.6122 3.72113 36 6.66665 36Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0267 44C20.0267 40.8174 21.291 37.7652 23.5414 35.5147C25.7918 33.2643 28.8441 32 32.0267 32C35.2093 32 38.2615 33.2643 40.512 35.5147C42.7624 37.7652 44.0267 40.8174 44.0267 44H20.0267Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0267 29.3334C36.0768 29.3334 39.36 26.0501 39.36 22C39.36 17.9499 36.0768 14.6667 32.0267 14.6667C27.9766 14.6667 24.6934 17.9499 24.6934 22C24.6934 26.0501 27.9766 29.3334 32.0267 29.3334Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireIcon2);
export default __webpack_public_path__ + "static/media/hireIcon2.efaac51da8b34add686d2d9e233d6b4a.svg";
export { ForwardRef as ReactComponent };